<div class="spinner-overlay" *ngIf="!orden">
  <div class="spinner"></div>
</div>

<div class="container">
  <div class="row" style="margin-top:100px">

    <div class="col-lg-8 col-lg-offset-2 ">
      <h4 style="text-align:left"> Respuesta de la Transacción </h4>
      <hr>
    </div>
    <div class="col-lg-8 col-lg-offset-2 ">
      <div class="table-responsive">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td>Referencia</td>
              <td id="referencia">{{orden?.idTRXPasarela}}</td>
            </tr>
            <tr>
              <td class="bold">Fecha</td>
              <td id="fecha" class="">{{orden?.creationDate}}</td>
            </tr>
            <tr>
              <td>Estado</td>
              <td id="respuesta">{{orden?.estado==1? 'APROBADA': (orden?.estado==2?'Rechazada':(orden?.estado==3?'En Proceso / Espera unos minutos y en caso contrario contactate con nuestro servicio al cliente':'En Proceso'))}}</td>
            </tr>
    
            <tr *ngIf="banco">
              <td class="bold">Banco</td>
              <td class="" id="banco">{{banco}}</td>
            </tr>
            <tr>
              <td class="bold">Recibo</td>
              <td id="recibo">{{orden?.id}}</td>
            </tr>
            <tr *ngIf="valor">
              <td  class="bold">Total</td>
              <td class="" id="total">{{valor}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>
<footer>
  <div class="row">
    <div class="container">
      <div class="col-lg-8 col-lg-offset-2">
        <img
          src="https://static.placetopay.com/placetopay-logo.svg"
          style="margin-top:10px; float:left"> 
      </div>
    </div>
  </div>

</footer>